export default __webpack_public_path__ + "src/images/packages/lush-private-game-lodge/47a58d27bf07443f14c58078dc53c847-4.jpg";